(() => {
  'use strict';
  let timer, running = false, again = false;
  async function refresh() {
    const host = document.querySelector('#rebuy-cart [data-rebuy-cart-anchor="body"]');
    if (!host) return;
    if (running) { again = true; return; }
    running = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + '?section_id=gb-three-tees', {credentials:'same-origin', cache:'no-store'});
      if (!response.ok) throw new Error('Offer unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const card = doc.querySelector('[data-gb-three-tees]');
      const old = host.querySelector('[data-gb-three-tees]');
      if (card) { if (old) old.replaceWith(card); else host.append(card); }
      else if (old) old.remove();
      const placed=host.querySelector('[data-gb-three-tees]');
      const items=host.querySelector('[data-rebuy-component="cart-items"]');
      if(placed && items && items.nextElementSibling!==placed)items.after(placed);
      const shipping=doc.querySelector('[data-gb-cart-shipping]');
      const prior=host.querySelector('[data-gb-cart-shipping]');
      if(shipping){if(prior)prior.replaceWith(shipping);else host.prepend(shipping);}else prior?.remove();
      labels();
    } catch (_) {
      host.querySelector('[data-gb-three-tees]')?.remove();
      host.querySelector('[data-gb-cart-shipping]')?.remove();
    } finally { running = false; if (again) { again = false; schedule(); } }
  }
  function labels(){
    const widget=document.querySelector('#rebuy-cart [data-rebuy-id="290288"]');if(!widget)return;
    const title=widget.querySelector('.primary-title');if(title && title.textContent!=='Popular picks')title.textContent='Popular picks';
    widget.querySelectorAll('.rebuy-product-actions button').forEach(button=>{
      const span=button.querySelector('span');
      if(span && /^(Options|Size|Choose size)$/i.test(span.textContent.trim())){
        if(span.textContent!=='Choose size')span.textContent='Choose size';
        const product=button.closest('.rebuy-product-block')?.querySelector('.rebuy-product-title-link')?.textContent||'';
        const label='Choose size for '+product;if(button.getAttribute('aria-label')!==label)button.setAttribute('aria-label',label);
      }
    });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 180); }
  ['rebuy.ready','rebuy.productsChange','rebuy:cart.change','rebuy:cart.show','cart:updated','theme:cart:change','baseline:cart:afteradditem','baseline:cart:update','baseline:cart:cartqtychange'].forEach(event => document.addEventListener(event, schedule));
  const observer = new MutationObserver(records => {
    labels();
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.id === 'rebuy-cart' || node.querySelector?.('#rebuy-cart'))))) schedule();
  });
  function start() { observer.observe(document.body, {childList:true,subtree:true}); schedule(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
